<template>
    <div class="complexity rt-h-screen rt-flex rt-justify-center rt-items-center">
        <div class="rt-w-5/6 rt-rounded-tl-lg rt-rounded-bl-lg
            sm:rt-w-3/5
        ">
            <div class="rt-flex">
                <div class="rt-w-full rt-bg-white rt-rounded-lg">
                    <div class="rt-p-4">
                        <h1 class="rt-text-5xl rt-font-bold rt-text-red-700">Complexity (How Steep and Difficult)</h1>
                        <p>Intricate roof lines with more asymmetrical architecture costs more because they are more labor intensive and time consuming.</p>
                    </div>
                    <div class="rt-bg-gray-200 rt-p-4">
                        <label for="" class="rt-text-gray-600">Choose One: </label>
                        <div class="rt-flex rt-flex-row rt-mt-10">
                            <div class="rt-w-1/3 rt-p-2 rt-flex rt-items-top rt-justify-center  rt-mb-6 group rt-cursor-pointer
                            sm:rt-items-center" @click="selectComplexity('simple')" @mouseover="onMouseOver('simple')" @mouseleave="onMouseLeave">
                                
                                <div class="rt-flex rt-flex-col rt-text-center ">
                                    <img :src="simpleImg" alt="Simple" >

                                    <div class="rt-block rt-mt-2">
                                        <span class="rt-mr-2 rt-h-4 rt-w-4 rt-bg-gray-700 rt-rounded-full group-hover:rt-bg-red-700 rt-hidden
                                            sm:rt-mr-6 sm:rt-inline-block
                                        " :class="{'rt-bg-red-700': complexityModel == 'simple'}"></span>
                                        <span class="rt-text-gray-700 rt-mt-2 rt-text-sm group-hover:rt-text-red-700
                                        sm:rt-text-base" :class="{'rt-text-red-700': complexityModel == 'simple'}">Simple</span>
                                    </div>
                                </div>

                            </div>
                            <div class="rt-w-1/3 rt-p-2 rt-flex rt-items-top rt-justify-center rt-mb-6 group rt-cursor-pointer
                            sm:rt-items-center" @click="selectComplexity('more-complex')" @mouseover="onMouseOver('more-complex')" @mouseleave="onMouseLeave">
                                
                                <div class="rt-flex rt-flex-col rt-text-center">
                                    <img :src="moderateImg" alt="Moderate">
                                    <div class="rt-block rt-mt-2" >
                                        <span class="rt-mr-6 rt-h-4 rt-w-4 rt-bg-gray-700 rt-rounded-full group-hover:rt-bg-red-700 rt-hidden
                                            sm:rt-mr-6 sm:rt-inline-block
                                        " :class="{'rt-bg-red-700': complexityModel == 'more-complex'}"></span>
                                        <span class="rt-text-gray-700 rt-mt-2 rt-text-sm group-hover:rt-text-red-700
                                        sm:rt-text-base
                                        " :class="{'rt-text-red-700': complexityModel == 'more-complex'}">Moderate</span>
                                    </div>
                                </div>
                            </div>
                            <div class="rt-w-1/3 rt-p-2 rt-flex rt-items-top rt-justify-center rt-mb-6 group rt-cursor-pointer
                            sm:rt-items-center" @click="selectComplexity('complex')" @mouseover="onMouseOver('complex')" @mouseleave="onMouseLeave">
                                    
                                <div class="rt-flex rt-flex-col rt-text-center">  
                                    <img :src="complexImg" alt="Complex">
                                    <div class="rt-block rt-mt-2" >
                                        <span class="rt-mr-6 rt-h-4 rt-w-4 rt-bg-gray-700 rt-rounded-full group-hover:rt-bg-red-700 rt-hidden
                                            sm:rt-mr-6 sm:rt-inline-block
                                        " :class="{'rt-bg-red-700': complexityModel == 'complex'}"></span>
                                        <span class="rt-text-gray-700 rt-mt-2 rt-text-sm group-hover:rt-text-red-700
                                        sm:rt-text-base
                                        " :class="{'rt-text-red-700': complexityModel == 'complex'}">Complex</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p class="rt-mt-2 rt-text-center">
                            <svg class="rt-inline-block" width="13" height="13" xmlns="http://www.w3.org/2000/svg"><path d="M6.5 0A6.505 6.505 0 000 6.5c0 1.395.45 2.68 1.2 3.738-.03.064-.068.135-.117.233-.35.708-.678 1.35-1.05 2.08a.317.317 0 00.05.347.317.317 0 00.343.078l2.49-1.025A6.618 6.618 0 006.5 13c3.586 0 6.5-2.914 6.5-6.5S10.086 0 6.5 0zm0 .619A5.876 5.876 0 0112.381 6.5c0 3.252-2.63 5.88-5.881 5.88-1.24 0-2.442-.379-3.385-1.03a.315.315 0 00-.29-.028l-1.863.769c.228-.454.435-.856.678-1.345l.14-.285c.017-.036.028-.067.038-.092.047-.1.045-.25-.024-.339A5.843 5.843 0 01.62 6.5 5.876 5.876 0 016.5.62zm0 1.238a3.1 3.1 0 00-3.095 3.095c0 .566.155 1.096.422 1.551.06.1.122.194.177.278.337.535.639.91.639 1.731 0 .162.147.31.31.31h3.095c.162 0 .31-.148.31-.31 0-.822.3-1.196.638-1.731.042-.071.095-.146.135-.207.292-.471.464-1.026.464-1.622A3.1 3.1 0 006.5 1.857zm0 .62a2.472 2.472 0 012.135 3.72c-.052.085-.104.163-.152.235-.284.454-.631.971-.711 1.77H5.228c-.08-.799-.427-1.316-.711-1.77-.065-.099-.132-.206-.186-.294A2.472 2.472 0 016.5 2.476h-.001zm.895 1.232a.314.314 0 00-.16.073L5.687 5.02a.317.317 0 00-.105.304c.024.11.113.203.222.233l.7.189-.686.686a.322.322 0 00-.007.442.322.322 0 00.442-.002L7.327 5.8c.152-.154.069-.462-.14-.518l-.629-.164 1.064-.851a.32.32 0 00.104-.367.319.319 0 00-.331-.19zM5.078 9.286a.322.322 0 00-.295.324.322.322 0 00.324.295h2.786a.322.322 0 00.314-.31.322.322 0 00-.314-.31H5.078zm.62 1.238a.322.322 0 00-.296.324.322.322 0 00.324.295h1.548a.322.322 0 00.314-.31.322.322 0 00-.314-.31H5.697z" fill="#F04D4E" fill-rule="nonzero" opacity=".6"/></svg>
                            <span class="rt-text-lg rt-italic rt-text-gray-900 rt-ml-2">{{ description }}</span>
                        </p>
                    </div>
                    <div class="rt-p-4">
                        <div class="rt-flex rt-justify-around rt-my-4">
                            <button type="button" class="rt-bg-red-600 rt-w-32 rt-h-10 rt-rounded rt-text-white rt-text-lg" @click="prevStep">BACK</button>
                            <button type="button" class="rt-bg-red-600 rt-w-32 rt-h-10 rt-rounded rt-text-white rt-text-lg" @click="nextStep">NEXT</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
    name: 'Complexity',
    computed: {
        stepModel: {
            get() {
                return this.step
            },
            set(value) {
                this.setStep(value)
            }
        },
        complexityModel: {
            get() {
                return this.complexity
            },
            set(value) {
                this.setComplexity(value)
            }
        },
        complexityHoverModel: {
            get() {
                return this.complexityHover
            },
            set(value) {
                this.setComplexityHover(value)
            }
        },
        ...mapState({
            step: state => state.Common.step,
            complexity: state => state.Complexity.complexity,
            complexityHover: state => state.Complexity.complexityHover,
        }),
        description() {
            let description = 'Simple: a basic walkable roof, such as ranch style house'
            if(this.complexityHoverModel) {
                switch(this.complexityHoverModel) {
                    case 'more-complex':
                        description = 'A less walkable roof, with multiple valleys and intersections such as a 2 story colonial'
                        break;
                    case 'complex':
                        description = 'Intricate roof lines, dead-end intersections, steep, non-walkable roof lines'
                        break;
                }

                return description
            }

            switch(this.complexityModel) {
                case 'more-complex':
                    description = 'More complex: a center story colonial with multiple angles and intersections'
                    break;
                case 'complex':
                    description = 'Very complex: dormers, multiple valleys, dead-end interventions (complex architectures)'
                    break;
            }

            return description


        },
        simpleImg() {
            return `${window.roofingData.pluginUrl}dist/${require('@/assets/images/Simple.jpg')}`
        },
        moderateImg() {
            return `${window.roofingData.pluginUrl}dist/${require('@/assets/images/Moderate.jpg')}`
        },
        complexImg() {
            return `${window.roofingData.pluginUrl}dist/${require('@/assets/images/Complex.jpg')}`
        },
    },
    methods: {
        ...mapMutations("Common", [
            'setStep',
        ]),
        ...mapMutations("Complexity", [
            'setComplexity',
            'setComplexityHover',
        ]),
        nextStep() {
            this.stepModel = 'material';
        },
        prevStep() {
            this.stepModel = 'shingle-layers';
        },
        selectComplexity(complexity) {
            this.complexityModel = complexity
        },
        onMouseOver(complexity) {
            this.complexityHoverModel = complexity
        },
        onMouseLeave() {
            this.complexityHoverModel = null
        }
    }
}
</script>

<style lang="scss" scoped>
    .complexity {
        background: #2B2B2B;
    }
</style>